var _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "uil-facebook",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    fill: "#ffffff",
    className: "bk"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -30,
    width: 20,
    height: 60,
    fill: "#fb6a66",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: 2,
    to: 1,
    begin: "0s",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.1 0.9 0.4 1",
    keyTimes: "0;1",
    values: "2;1"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -30,
    width: 20,
    height: 60,
    fill: "#fb6a66",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: 2,
    to: 1,
    begin: "0.1s",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.1 0.9 0.4 1",
    keyTimes: "0;1",
    values: "2;1"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -10,
    y: -30,
    width: 20,
    height: 60,
    fill: "#fb6a66",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "scale",
    from: 2,
    to: 1,
    begin: "0.2s",
    repeatCount: "indefinite",
    dur: "1s",
    calcMode: "spline",
    keySplines: "0.1 0.9 0.4 1",
    keyTimes: "0;1",
    values: "2;1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.4a6625e5.svg";
export { ForwardRef as ReactComponent };